module.exports = __webpack_public_path__ + "5673b361af22089139bd443516f6e707.csv";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-group/accounts/import/import-accounts-to-group.sample.csv
// module id = 1795
// module chunks = 0